import { render, staticRenderFns } from "./CultureValues.vue?vue&type=template&id=0c6f1416&"
import script from "./CultureValues.vue?vue&type=script&lang=js&"
export * from "./CultureValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports